// extracted by mini-css-extract-plugin
module.exports = {"icon":"BackButton_icon__3j3Ma"};